module.exports = __webpack_public_path__ + "img/Technology_PC_JP@3x.f6dd285a.png";